export default {
    MergeFindRowsResponse: {
        datapoint: {
            name: 'TnS_MergeFindResponse',
            customData: function (isDataUptodate) {
                return [isDataUptodate];
            },
        },
    },
};
//# sourceMappingURL=datapoints.js.map